import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["content", "maxHeight"];
import * as React from 'react';

// 新结构

/**
 * 文字 字体、大小、行高
 * @param props
 */
var RichText = function RichText(props, ref) {
  var _props$content = props.content,
    content = _props$content === void 0 ? {
      subject: '',
      description: ''
    } : _props$content,
    _props$maxHeight = props.maxHeight,
    maxHeight = _props$maxHeight === void 0 ? 'auto' : _props$maxHeight,
    others = _objectWithoutPropertiesLoose(props, _excluded);
  var oldType = typeof content === 'string';
  var desc = oldType ? content : (content === null || content === void 0 ? void 0 : content.description) || '';
  var title = !oldType && (content === null || content === void 0 ? void 0 : content.subject) || '';
  var hideTitle = oldType || (content === null || content === void 0 ? void 0 : content.hideTitle);
  return /*#__PURE__*/React.createElement("div", _extends({}, others, {
    ref: ref
  }), !hideTitle && /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: '30px',
      color: '#333',
      lineHeight: '32px'
    }
  }, /*#__PURE__*/React.createElement("span", null, title)), /*#__PURE__*/React.createElement("div", {
    style: {
      maxHeight: maxHeight,
      overflowY: 'scroll'
    },
    className: "message-content",
    dangerouslySetInnerHTML: {
      __html: desc
    }
  }));
};
var RefRichText = /*#__PURE__*/React.forwardRef(RichText);
RefRichText.defaultProps = {
  content: {
    subject: '需求标题',
    hideTitle: false,
    description: '<div><span>- 你可以在这里描述需求</span><br /><span>- 或者粘贴需求截图</span></div>'
  },
  className: ''
};
export default RefRichText;